import React from 'react';
import { Link } from 'react-router-dom'
import OrgsSmallCommentInput from './OrgsSmallCommentInput'
import PostAvatar from '../../Post/PostAvatar'
import {getLabel} from "../../../language";
import connect from "react-redux/src/components/connect";
import {ABUSE} from "../../../constants/actionTypes";
import agent from "../../../agent";
import {orgsLoadComments} from "../../../actions/OrgsComments";
import {message, Popconfirm} from "antd";

const mapStateToProps = (state, ownProps) => {
    return {
        anonymousMode: state.user.anonymousMode,
        currentUser: state.common.currentUser,
    }
}

const mapDispatchToProps = dispatch => ({
    abuse: payload => dispatch({
        type: ABUSE,
        payload: agent.Abuse.setAbuse(payload)
    }),
    getCommentList: dispatch(orgsLoadComments)
});

class OrgsSmallComment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            replies: [],
            reaction:[]
        }
    }

    componentDidMount() {
        if(Array.isArray(this.props?.abuseData?.myAbuse)){
            this.props.abuseData.myAbuse.map((item)=>{
                if(!this.state.reaction.includes(item)) {
                    this.setState(prevState => ({
                        reaction: [
                            ...prevState.reaction,
                            item.abuseType
                        ]
                    }))
                }
            })
        }
    }

    componentWillMount () {
        const { replies } = this.props;
        this.repliesSorting(replies);
    }

    componentWillReceiveProps (nextProps) {
        const { replies } = nextProps;
        this.repliesSorting(replies);
    }

    repliesSorting = (replies) => {
        if (replies && Array.isArray(replies)) {
            const repliesSort = replies.sort((firstComment, secondComment) => {
                return firstComment.dateCreated < secondComment.dateCreated ? -1 : 1
            });
            this.setState({
                replies: repliesSort
            })
        }
    }

    getDisplayNameFromMentions = (userName) => {
        const props = this.props
        if (props.mention ) {
            const mentionUser = props.mention.find(res => res.id === userName);
            return mentionUser && mentionUser.display && mentionUser.display
        }
        return userName;
    }

    parseBody = body => {
        var matchedMentions = body.match(/\[~(.*?)\]/g);
        let content = body;
        if (matchedMentions && matchedMentions.length > 0) {
            matchedMentions.map(res => {
                const userName = res.match(/\[~(.*?)\]/).pop();
                const displayName = this.getDisplayNameFromMentions(userName);
                content = content.replace(res, `<a href=/@${userName}>${displayName}</a>`);
            })
        }

        return { __html: content };
    }

    handleDeleteOrgsComment = async () => {
        let formData = new FormData();
        let data = {}
        data.EntityId = this.props.id
        data.EntityType = "OrganisationComment"
        for (const key in data) {
            formData.append(key, data[key]);
        }
        await agent.DeleteComment.deleteComment(formData).then(res => {
            this.props.getCommentList(this.props.organisationId);
        }).catch(err => console.log('Oh no!', err));
    }

    handleReaction = (name) => {
        if(!this.state.reaction.includes(name)) {
            this.setState(prevState => ({
                reaction: [
                    ...prevState.reaction,
                    name
                ]
            }))
        }
        this.props.abuse( {
            "EntityId": this.props.id,
            "EntityType":"OrganisationComment",
            "AbuseType": name,
            "AuthorId":this.props.author.id,
        });
    };

    handleReportAbuse = () =>{
        message.error(getLabel(338));
    }

    render() {
        const {author, dateCreated, anonymousMode } = this.props;
        const { reaction } = this.state
        const mayReportAbuse = this.props?.currentUser?.user_privilege?.mayReportAbuse

        return (
            <div className={`comment ${anonymousMode ? "bgl cw" : ""} `}>
                <header>
                    <div className="facebook-reaction col-md-1 fr">
                        {mayReportAbuse ? <span className="like-btn">
                                            <span
                                                className="like-btn-text ml-35">Abuse?</span>
                                                <ul className={`${this.props.anonymousMode ? "reactions-box-dark" : "reactions-box"}`}>
                                                    <span className="reaction reaction-vulgar" onClick={()=>{this.handleReaction("Vulgar" )}} data-reaction="Vulgar"/>
                                                    <span className="reaction reaction-irrelevant" onClick={()=>{this.handleReaction("Irrelevant" )}} data-reaction="Irrelevant"/>
                                                    <span className="reaction reaction-pointless" onClick={()=>{this.handleReaction("Pointless" )}} data-reaction="Pointless"/>
                                                </ul>
                                            </span> : <span className="like-btn-text" onClick={()=>this.handleReportAbuse()}>Abuse?</span>}
                        <div className="like-stat">
                            <span className="like-emo">{reaction && reaction.map((item)=>(<span className={`like-btn-${item || ""}`}></span>)) }</span> <span className="like-details">you</span>
                        </div>
                        <div className="delete-comment">
                            {
                                this.props?.currentUser?.roles[0] === "Admin" &&
                                <div style={{ marginLeft: 70, clear: 'both', whiteSpace: 'nowrap' }}>
                                <Popconfirm placement="bottomLeft" title={getLabel(310)} onConfirm={() => this.handleDeleteOrgsComment()} okText="Yes" cancelText="No">
                                <div style={{display: "flex", alignItems: "center", color:"#43c5e6"}}>
                                <i className="fa fa-trash"/>
                                </div>
                                </Popconfirm>
                                </div>
                            }
                        </div>
                    </div>
                    <div className="authorimage">
                        <a className="politician">
                            <PostAvatar userName={author.userName} />
                            <span className={`${parseInt(author.gender) === 1 && "female "}${parseInt(author.gender) === 2 && " male"}`} />
                        </a>
                    </div>
                    <div className="articletitle">
                        <div className="author" style={{display: 'inline-block'}}><Link to={`/@${author && author.userName}`}>{author.displayName}, {author.displayLocation}</Link> {getLabel(163)}</div>
                        <div className="date m-0" >{dateCreated && new Date(dateCreated).toDateString()+" "+new Date(dateCreated).toLocaleTimeString('en-US')}</div>
                        {this.props.replyMyPostsAndComments === 1 && <div style={{display: 'inline-block', float: 'right', color: 'blue'}}>{getLabel(164)}</div>}
                    </div>
                </header>

                {/*<div className="text form-group" >{this.props.body}</div>*/}
                <div className="text form-group" dangerouslySetInnerHTML={this.parseBody(this.props.body)} />
                <div className="row">
                    <div className="offset-md-1 col-md-11">
                        { this.state.replies.length > 0 && this.state.replies.slice(-1).map((repComment, index) => {
                            return (
                                <div key={index} className="form-group">
                                    <header>
                                        <div className="authorimage">
                                            <a className="politician">
                                                <PostAvatar userName={repComment.author.userName} />
                                                <span className={`${parseInt(repComment.author.gender) === 1 && "female "}${parseInt(repComment.author.gender) === 2 && " male"}`} />
                                            </a>
                                        </div>
                                        <div className="articletitle">
                                            <div className="author" style={{display: 'inline-block'}}><Link to={`/@${repComment.author && repComment.author.userName}`}>{repComment.author.displayName}, {repComment.author.displayLocation}</Link>{getLabel(165)}</div>
                                            <div className="date m-0" >{repComment.dateCreated && new Date(repComment.dateCreated).toDateString()+" "+new Date(repComment.dateCreated).toLocaleTimeString('en-US')}</div>
                                            {repComment.replyMyPostsAndComments === 1 &&
                                            <div style={{display: 'inline-block', float: 'right', color: 'blue'}}>{getLabel(164)}</div>}
                                        </div>
                                    </header>
                                    {/*<div className="text form-group" dangerouslySetInnerHTML={this.parseBody(this.props.body)} />*/}
                                    <div className="text" dangerouslySetInnerHTML={this.parseBody(repComment.body)} />
                                </div>
                            )
                        }) }
                        {/*{this.state.replies.length > 1 && this.props.goal &&*/}
                        {/*<Link to={`/goals/${this.props.goal.slug}`} className="viewall">{getLabel(207)}</Link>*/}
                        {/*}*/}
                        {/*<OrgsSmallCommentInput*/}
                        {/*    replyComment={true}*/}
                        {/*    avatar={this.props.user && this.props.user.avatar ? this.props.user.avatar : null}*/}
                        {/*    orgs={this.props.orgs}*/}
                        {/*    commentId={this.props.id}*/}
                        {/*    isAvailableForReply={this.props.isAvailableForReply}*/}
                        {/*    replyMyPostsAndComments = {this.props.replyMyPostsAndComments}*/}
                        {/*/>*/}
                    </div>
                </div>
            </div>
        );
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(OrgsSmallComment)
